import { createAPI } from '../../common'

export default {
  getpaperList: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0f60mjtuebub', 'get', config, vconfig),
  postPaperList: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0f60mjtuebub', 'post', config, vconfig),
  // 获取全部报纸
  getPaperAll: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0qbqfs0bmm', 'get', config),
  // 读角色权限：
  getPermissionsActions: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0qbqfs0qfsnjttjpot0bdujpot', 'get', config),
  // 数字报左侧按钮栏目权限
  postPermissionsActions: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0f60bdujpot', 'get', config),
  // 启用数字报
  getPaperSetEnabled: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0qbqfsTfu0fobcmfe', 'get', config),
  // 禁用数字报
  getPaperSetDisabled: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0qbqfsTfu0ejtbcmfe', 'get', config),
  //  保存数字报显示样式
  postRule: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0qbqfsTfu0svmf', 'post', config, vconfig),
  //  保存数字报显示样式
  postStyle: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0qbqfsTfu0tuzmf', 'post', config, vconfig),
  //  数字报版面更新排序
  postPaperLayoutOrder: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0qbqfsMbzpvu0psefs',
      'post',
      config,
      vconfig
    ),
  //  修改报纸版面名称
  postPaperLayoutName: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0qbqfsMbzpvu0obnf', 'put', config),
  //  修改报纸版面
  postPaperLayoutUpdate: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0qbqfsMbzpvu0vqebuf', 'put', config),
  //  报纸版面发布
  postPaperLayoutPublish: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0qbqfsMbzpvu0qvcmjti',
      'post',
      config,
      vconfig
    ),
  //  报纸版面重发
  postPaperLayoutRepublish: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0qbqfsMbzpvu0sfqvcmjti',
      'post',
      config,
      vconfig
    ),
  //  报纸版面撤版
  postPaperLayoutRevoke: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0qbqfsMbzpvu0sfwplf',
      'post',
      config,
      vconfig
    ),
  // 更新报纸
  getPaperPaperSetUpdate: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0qbqfsTfu0vqebuf', 'get', config),
  // 版面删除接口，
  paperDeletePaperLayout: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0qbqfsMbzpvu', 'delete', config),
  // 获取版面详情
  getPaperPaperLayout: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0qbqfsMbzpvu', 'get', config),
  // 获取稿件详情
  getPaperGetPaperArticle: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0qbqfsBsujdmf', 'get', config),
  // 修改稿件详情
  getPaperPostPaperArticle: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0qbqfsBsujdmf', 'post', config, {
      ...vconfig,
      isSimpleSecurity: true
    }),
  // 稿件上版
  PostPaperArticlePublish: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0qbqfsBsujdmf0qvcmjti', 'post', config),
  // 稿件下版
  PostPaperArticleRevoke: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0qbqfsBsujdmf0sfwplf', 'post', config),
  // 报纸删除接口，
  paperDeletePaperArticle: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0qbqfsBsujdmf', 'delete', config),
  // 获取转版稿件列表
  getPaperGetTransfer: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0qbqfsBsujdmf0usbotgfs', 'get', config),
  // 获取数字报显示样式
  getPaperSetStyle: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0qbqfsTfu0tuzmf', 'get', config),
  // 获取数字报发布设置
  getPaperSetRule: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0qbqfsTfu0svmf', 'get', config),
  // 稿件转版操作（合成和还原）
  getPaperPostTransfer: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0qbqfsBsujdmf0usbotgfs',
      'post',
      config,
      vconfig
    ),
  // 版面发布页查看
  getPaperLayoutView: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0qbqfsMbzpvu0wjfx', 'get', config),
  // 版面发布页预览
  getPaperLayoutPreview: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0qbqfsMbzpvu0qsfwjfx', 'get', config),
  // 样式网站模板 触屏模板 数据
  getTemplateData: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.xfc0f60mjtuebub', 'post', config, vconfig),
  // 发布样式网站发布规则 触屏发布规则 数据
  getReleaseRuleData: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.tjuf0f60mjtuebub', 'post', config, vconfig),
  getPhotoDownload: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0qipup0epxompbe', 'get', config, vconfig), // 智慧预发布
  // 稿件发布
  PostPaperArticleSavePublish: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0qbqfsBsujdmf0tbwfQvcmjti', 'post', config),
  // 小样解锁
  postE5Unlocker: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0f60bdujpot0vompdlfs',
      'post',
      config,
      vconfig
    ),
  // 获取报纸下所有版次
  getPaperAllLayout: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0qbqfsMbzpvu0hfuBmmMbzpvu', 'get', config),
  // 数字报统计列表
  PostPaperDigitalPaperList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tubu0xpslmpbe0ejhjubmQbqfs', 'post', config),
  // 数字报版面重发
  PostPublishByDate: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0qbqfsMbzpvu0qvcmjtiCzEbuf',
      'post',
      config
    ),
  // 数字报统计总和
  PostPaperDigitalPaperTotal: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tubu0xpslmpbe0ejhjubmQbqfs0upubm', 'post', config),
  // 根据选择版本获取修改痕迹
  getArticlesTracesByVersion: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0wfstjpo0usbdf0wfstjpot0tfmfdu',
      'get',
      config,
      vconfig
    ),
  // 稿件详情
  getArticlesDetails: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0qbqfsBsujdmf', 'get', config, vconfig),
  // 修改痕迹 - 所有
  getAllArticlesTraces: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0wfstjpo0usbdf0bmm', 'get', config),
  // 获取不同用户修改痕迹(新)
  getArticlesTracesByDifUserNew: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0wfstjpo0usbdf0vtfst0bmufsobuf0ofx',
      'get',
      config,
      vconfig
    ),
  // 获取版面详情
  saveLayoutAnimation: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0qbqfsMbzpvu0tbwfBojnbujpo',
      'post',
      config
    ),
  // 选用编辑
  PostSelect4Edit: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0qbqfsBsujdmf0tfmfdu5Feju', 'post', config),
  // 获取数字报阅读策略
  getPaperReadRule: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0qbqfsTfu0sfbeSvmf', 'get', config),
  // 保存数字报阅读策略
  postPaperReadRule: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0qbqfsTfu0sfbeSvmf', 'post', config)
}
